// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb3a7cd2","698":"22d5f783"}[chunkId] + ".chunk.js";
};